'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './gallery-edit.routes';

export class GalleryEditComponent {

  constructor(Auth, $uibModal, $stateParams, $state, $location, dialogs, StorageService, GalleryService, Upload, $q, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.$uibModal = $uibModal;
    this.StorageService = StorageService;
    this.GalleryService = GalleryService;
    this.Upload = Upload;
    this.Auth = Auth;

    this.isAdmin = this.Auth.isAdminSync;

    this.galleryId = $stateParams.id;
    this.galleryType = $stateParams.type;

    this.$state = $state;
    this.$location = $location;
    this.dialogs = dialogs;
    this.$q = $q;

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Gallery Editor");

    this.toolbarDefinition = [
      ["bold","italics","underline","strikeThrough"],
      ["h3","h4","h5"],
      ["p","pre","quote","clear"],
      ["ul","ol"],
      ["justifyLeft","justifyCenter","justifyRight","justifyFull"],
      ["indent","outdent"],
      ["undo","redo"],
      ["html"],
      ["archiveImageLink", "insertImage","insertLink","insertVideo"]
    ];

    this.galleryTemplate = {
      title: '',
      description: '',
      type: this.galleryType,
      meta: {
        creationUser: Auth.getCurrentUserSync()._id,
        active: true
      }
    };

    this.assets = [];
    this.gallery = angular.copy(this.galleryTemplate);

    if (this.galleryId) {
      this.GalleryService.get({id: this.galleryId}, data => {
        this.gallery = data;
        this.assets = data.images;
      }, err => {
        console.log('Could not load gallery from server');
      })
    }

    var that = this;

    this.dropHandler = function( file, insertAction ) {

      var isImage = that.isImageMime(file.type);

      // validation
      if( !isImage ) {
        // ignore other file than images and pdfs
        return;
      }

      /* could check for file size: if( file.size > 500000 ) */

      var defer = that.$q.defer();

      that.Upload.upload({
        url: '/api/storage',
        data: {
          name: file.name,
          file: file,
          storageStrategy: 'local',
          isPublic: true,
          creationUser: that.Auth.getCurrentUserSync()._id,
          active: true
        }
      }).then((response) => {

        let storageId = response.data;

        if (!that.gallery.featureImage) {
          that.gallery.featureImage = storageId;
        }

        that.assets.push({
          title: '',
          image: storageId
        });

      }, (response) => {
        if (response.status > 0) {
          alert(response.status + ': ' + response.data);
          defer.reject();
        }
      });

      return defer.promise;

    };
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  removeAsset(idx) {
    // Check if the removed image is going to be the feature image
    var featureImageRemoved = this.assets[idx].image == this.gallery.featureImage;

    // remove the image
    this.assets.splice(idx,1);

    // if the feature image is removed and there are still images in the gallery,
    // set the feature image to the first image in the gallery
    if (featureImageRemoved && this.assets.length > 0) {
      this.gallery.featureImage = this.assets[0].image;
    }

    if (this.assets.length == 0) {
      // If there is no image left, delete the featureImage attribute
      delete this.gallery.featureImage;
    }
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = data => {
        this.gallery = angular.copy(this.galleryTemplate);
        this.submitted = false;

        var actionString = (this.galleryId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "Your image gallery has been "+actionString+" successfully");
        dlg.result.then(() => {

          var id = that.galleryId || data._id;

          if (id) {
            // If this is gallery edit: go back to the gallery detail page
            that.$location.path("/gallery/" + id);
          } else {
            // If this is a new gallery, go to the overview page after creation
            that.$state.go(that.galleryType + "-gallery-list");
          }
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.gallery.images = this.assets;

      if (this.galleryId) {  // Save changes on the current image gallery
        this.GalleryService.patch({id: this.galleryId},[
          { op: 'replace', path: '/title', value: this.gallery.title },
          { op: 'replace', path: '/description', value: this.gallery.description },
          { op: 'replace', path: '/images', value: this.gallery.images },
          { op: 'replace', path: '/featureImage', value: this.gallery.featureImage },
          { op: 'replace', path: '/isPublic', value: this.gallery.isPublic }
        ], onSuccess, onError);
      } else { // Create a new image gallery
        this.GalleryService.save(this.gallery, onSuccess, onError);
      }
    }
  }

  openAssetBrowserModal = function () {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetBrowser',
      resolve: {
        config: function() {
          return {
            restrictToUserAssets: !that.Auth.isAdminSync(),
            userId: that.Auth.getCurrentUserSync()._id,
            restrictToFileTypes: ["image/jpeg", "image/png"]
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (newlySelectedAssets) {

        if (!that.gallery.featureImage && newlySelectedAssets.length > 0) {
          that.gallery.featureImage = newlySelectedAssets[0]._id;
        }

        that.assets = that.assets.concat(newlySelectedAssets.map(function(asset){
          return {
            title: '',
            image: asset._id
          }
        }));
      },
      function () { /* cancel */ }
    );

  }

  openAssetUploadModal = function () {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {
            acceptedFileTypes: 'image/*'
          }
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        result.forEach(storageId => {
          if (!that.gallery.featureImage) {
            that.gallery.featureImage = storageId;
          }

          that.assets.push({
            title: '',
            image: storageId
          });
        });

      },
      function () { /* cancel */ }
    );

  }
}

export default angular.module('conduuApp.galleryEdit', [uiRouter])
  .config(routes)
  .component('galleryEdit', {
    template: require('./gallery-edit.html'),
    controller: GalleryEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/gallery/edit/gallery-edit.component.js